// extracted by mini-css-extract-plugin
module.exports = {"barChart":"styles_barChart__2QpNe","yAxisTitle":"styles_yAxisTitle__giJD-","xAxisTitle":"styles_xAxisTitle__750yN"};